module.exports = __webpack_public_path__ + "img/login-left-img.1c40900f.png";